import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const AdminActorContextTypename = "AdminActorContext" as const;

export const AdminActorContextFragment = graphql(`
  fragment AdminActorContextFields on AdminActorContext {
    __typename
    accountId
    accountUsername
  }
`);

interface Props {
  data: FragmentOf<typeof AdminActorContextFragment>;
}

export function AdminActorContext({ data }: Props) {
  const p = readFragment(AdminActorContextFragment, data);
  return (
    <ActorContextRow>
      {p.accountUsername} ({truncateId(p.accountId)})
    </ActorContextRow>
  );
}
